import { etokenApi } from "../apiClient/apiClient";

export const postAdvertisement = async (advertisementData) => {
    try {
      const response = await etokenApi.post("/advertisement/insertAdvertisement", advertisementData  );
      return response.data;
    } catch (error) {
      console.error("Error occurred while posting the advertisement data");
      throw error;
    }
  };

  export const toggleDoctorAccount = async (data) => {
    try {
      const response = await etokenApi.put("/doctor/doctorAccountToggle", data);
      return response.data;
    } catch (error) {
      console.error("Error toggling doctor account status");
      throw error;
    }
  };

export const fetchActiveAdvertisements = async (doctor_id, clinic_id) => {
    try {
      const response = await etokenApi.get("/advertisement/fetchActiveAdvertisements", {
        params: { doctor_id, clinic_id },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching active advertisements:", error);
      throw error;
    }
};

export const fetchAdvertisements = async (doctor_id, clinic_id, filter_type = "ALL") => {
  try {
    const response = await etokenApi.get("/advertisement/fetchAdvertisements", {
      params: { doctor_id, clinic_id, filter_type },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching advertisements:", error);
    throw error;
  }
};

  export const fetchClinicsByDoctorId = async (doctorId) => {
    try {
      const response = await etokenApi.get(`/doctor/fetchClinicsByDoctorId`, {
        params: { doctor_id: doctorId }, 
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching clinics by doctor ID");
      throw error;
    }
  };

  export const insertAdvertisementPayment = async (paymentData) => {
    try {
      const response = await etokenApi.post("/advertisement-payment/insertAdvertisementPayment", paymentData);
      return response.data;
    } catch (error) {
      console.error("Error inserting advertisement payment:", error);
      throw error;
    }
  };
  

  export const updateAdvertisement = async (data) => {
    try {
      const response = await etokenApi.put("/advertisement/updateAdvertisement", data);
      return response.data;
    } catch (error) {
      console.error("Error updating advertisement:", error);
      throw error;
    }
  };

  export const fetchAdvertisementPaymentsByAdId = async (adId) => {
    try {
      const response = await etokenApi.get("/advertisement-payment/fetchAdvertisementPaymentsByAdId",
        {
          params: { ad_id: adId },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching advertisement payments by ad ID:", error);
      throw error;
    }
  };

    export const updateAdvertisementPayment = async (data) => {
      try {
        const response = await etokenApi.put("/advertisement-payment/updateAdvertisementPayment", data);
        return response.data;
      } catch (error) {
        console.error("Error updating advertisement payment:", error);
        throw error;
      }
    };

    export const fetchAllExceptions = async () => {
      try {
        const response = await etokenApi.get("/exception/fetchAllExceptions");
        return response.data;
      } catch (error) {
        console.error("Error fetching exceptions");
        throw error;
      }
    };

    export const fetchAccounts = async () => {
      try {
        const response = await etokenApi.get("/registration/accounts");
        return response.data;
      } catch (error) {
        console.error("Error fetching accounts");
        throw error;
      }
    };
    
    export const fetchSpecializations = async (account_id) => {
      try {
        const response = await etokenApi.get("/registration/specializations", {
          params: { account_id }
        });
        return response.data;
      } catch (error) {
        console.error("Error fetching specializations");
        throw error;
      }
    };

    export const insertDoctor = async (doctorData) => {
      try {
        const response = await etokenApi.post("/doctor/addDoctor", doctorData);
        return response.data;
      } catch (error) {
        console.error("Error inserting doctor:", error);
        throw error;
      }
    };

    export const insertDoctorClinicSchedule = async (scheduleData) => {
      try {
        const response = await etokenApi.post("/doctor/schedule", scheduleData);
        return response.data;
      } catch (error) {
        console.error("Error inserting doctor clinic schedule:", error);
        throw error;
      }
    };

    export const insertClinic = async (clinicData) => {
      try {
        const response = await etokenApi.post("/doctor/addClinic", clinicData);
        return response.data;
      } catch (error) {
        console.error("Error inserting clinic:", error);
        throw error;
      }
    };

    export const fetchAllDoctors = async (doctor_id = null) => {
      try {
        const response = await etokenApi.post("/doctor/fetchAllDoctors", {
          doctor_id: doctor_id || undefined 
        });
        return response.data;
      } catch (error) {
        console.error("Error fetching doctors");
        throw error;
      }
    };
      
    // doctorId can be a number or string
export const fetchDoctorById = async (doctorId) => {
  try {
    const response = await etokenApi.post("/doctor/fetchAllDoctors", {
      doctor_id: doctorId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching doctor by ID:", error);
    throw error;
  }
};

export const fetchTokensForPatients = async (doctor_id, clinic_id) => {
  try {
    const response = await etokenApi.get("/token/fetchTokensForPatients", {
      params: { doctor_id, clinic_id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tokens for patients:", error);
    throw error;
  }
};

export const fetchDoctorProfileImage = async (doctor_id) => {
  try {
    const response = await etokenApi.get("/doctor/fetchImage", {
      params: { userId: doctor_id },
    });
    // Return the imageUrl from the response
    return response.data.imageUrl || "";
  } catch (error) {
    console.error("Error fetching doctor's profile image:", error);
    return ""; // fallback to empty string or a default image path
  }
};

export const updateDoctorRecall = async (doctor_id, recall = "N") => {
  try {
    const response = await etokenApi.put("/doctor/updateDoctor", {
      doctor_id,
      recall,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating doctor recall status:", error);
    throw error;
  }
};